import { typedStyles } from '@/utils/styleUtils';

export const styles = typedStyles({
  mapWrapper: {
    marginY: 1,
    position: 'relative',
    paddingBottom: '100%',
  },

  map: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'background.default',
    borderRadius: 4,
  },

  pin: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: 10,
    fontSize: 50,
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
  },
});
